<template>
  <div>
    <vs-popup
      class="holamundo"
      :title="$t('AddExpertizeShema')"
      :active.sync="isSidebarActiveLocal"
      @close="closeExpertizePopup"
      @cancel="closeExpertizePopup"
    >
      <vs-popup
        class="holamundo"
        :title="$t('AddProductGroup')"
        :active.sync="isSidebarActiveProductGroupLocal"
        @close="closeExpertizeProductGroupPopup"
        @cancel="closeExpertizeProductGroupPopup"
      >
        <ProductGroupForExpertizeAddNew
          @getProductGroupsList="getStockProductGroupsList"
          :isSidebarActive="isSidebarActiveProductGroupLocal"
        />
      </vs-popup>
      <div style="min-height: 400px">
        <b-row>
          <b-col>
            <vs-card>
              <b-row style="margin-top: 8px">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="'* ' + $t('CheckListShemaName')"
                    label-for="h-first-name"
                    style="font-weight: 600"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <vs-input
                    size="small"
                    v-model="checkListShemaName"
                    type="text"
                    class="w-full"
                    name="checkListShemaName"
                    v-validate="'required'"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('checkListShemaName')"
                    >{{ errors.first("checkListShemaName") }}</span
                  >
                </b-col>
              </b-row>
              <b-row style="margin-top: 8px" align-v="center">
                <b-col cols="4" align-self="center">
                  <b-form-group
                    :label="'* ' + $t('ProductGroup')"
                    label-for="h-first-name"
                    style="font-weight: 600"
                  >
                  </b-form-group>
                </b-col>
                <b-col cols="7">
                  <v-select
                    color="danger"
                    v-model="productGroup"
                    :options="productgroup_choices"
                    size="small"
                    label="name"
                    autocomplete
                    ref="selectElement"
                    name="productGroup"
                    v-validate="'required'"
                  >
                  </v-select>

                  <span class="text-danger text-sm" v-show="errors.has('productGroup')">{{
                    errors.first("productGroup")
                  }}</span>
                </b-col>
                <b-col
                  cols="1"
                  class="ml-0"
                  style="padding-left: 0px; margin-left: 0px !important"
                >
                  <b-button
                    variant="outline-light"
                    style="padding: 0px"
                    v-on:click="addProductGroup()"
                  >
                    <Icon
                      icon="ic:outline-settings"
                      width="20"
                      height="20"
                      v-b-tooltip.hover.bottom="$t('ProductGroupManagement')"
                      color="#7367F0"
                    />
                  </b-button>
                </b-col>
              </b-row>
            </vs-card>
          </b-col>
        </b-row>
        <div class="items-center pl-6 mt-0 mb-0">
          <b-row align-h="end">
            <b-col cols="3" md="auto" style="padding: 0px">
              <b-button
                class="bg-danger"
                style="border-color: white"
                v-on:click="closeExpertizePopup"
              >
                <Icon
                  icon="material-symbols:cancel-outline"
                  style="margin-right: 5px"
                  width="20"
                  height="20"
                />{{ $t("Cancel") }}
              </b-button>
            </b-col>
            <b-col cols="3" md="auto">
              <b-button
                class="bg-primary"
                style="border-color: white"
                v-on:click="submitData()"
              >
                <Icon
                  icon="material-symbols:save-outline"
                  style="margin-right: 5px"
                  width="20"
                  height="20"
                />{{ $t("Save") }}
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import { uuid } from "vue-uuid";
import { Validator } from "vee-validate";
import ProductGroupForExpertizeAddNew from "./ProductGroupForExpertizeAddNew.vue";
export default {
  components: { Icon, vSelect, AgGridVue, ProductGroupForExpertizeAddNew },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => {},
    },
  },
  data() {
    return {
      isSidebarActiveProductGroupLocal: false,
      ROLE: this.$store.state.AppActiveUser.ROLE,
      productgroup_choices: [],
      productGroup: "",

      checkListShemaId: "",
      checkListShemaName: "",
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
    };
  },
  methods: {
    addProductGroup() {
      this.isSidebarActiveProductGroupLocal = true;
    },
    submitData() {
      var createdId = uuid.v4();
      const vs = this.$vs;
      let method = "addExpertizeShema";
      this.$validator.validateAll().then((result) => {
        if (result) {
          let obj = {
            checkListShemaId: createdId,
            checkListShemaName: this.checkListShemaName,
            productGroupId: this.productGroup.value,
            productGroupName: this.productGroup.name,
          };
          if (this.data) {
            method = "updateExpertizeShema";
            obj = {
              checkListShemaId: this.checkListShemaId,
              checkListShemaName: this.checkListShemaName,
              productGroupId: this.productGroup.value,
              productGroupName: this.productGroup.name,
            };
          }

          this.$store
            .dispatch("stock/" + method, obj)
            .then((response) => {
              try {
                console.log(response);
                if (response.success == true) {
                  vs.notify({
                    text: response.message,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-center",
                  });
                  this.closeExpertizePopup();
                } else {
                  vs.notify({
                    text: response.message.toString(),
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center",
                  });
                }
              } catch (error) {
                console.log(error);
              }
            })
            .catch((error) => {
              return new Promise((resolve, reject) => {
                resolve(false);
              });
            });
        } else {
          vs.notify({
            text: this.$t("Validate"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      });
    },
    closeExpertizeProductGroupPopup() {
      this.isSidebarActiveProductGroupLocal = false;
    },
    closeExpertizePopup() {
      this.isSidebarActiveLocal = false;
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    getProductGroupList() {
      this.productGroupListOption = [];
      this.productgroup_choices = [];
      this.productGroupListOption = this.stockGroupExpertize;
      this.productGroupListOption.forEach((val, index) => {
        this.productgroup_choices.push({
          value: val.ProductGroupId,
          name: val.ProductGroupName,
        });
      });
    },
    getStockProductGroupsList() {
      const vs = this.$vs;
      this.$store.dispatch("stock/listStockProductGroupForExpertize").then((response) => {
        // let costumerList = JSON.parse(response.json);
        if (response.success == true) {
          console.log(response);
        } else
          console.log(
            response.statusText
          ); /*
					vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
      });
    },
  },
  created() {
    this.getStockProductGroupsList();
  },
  watch: {
    stockGroupExpertize(val) {
      this.getProductGroupList();
      return val;
    },
    companydata(val) {
      this.getCustomerList();
      return val;
    },
    data(val) {
      this.checkListShemaId = val.CheckListShemaId;
      this.checkListShemaName = val.CheckListShemaName;
      this.productGroup = {
        name: val.ProductGroupName,
        value: val.ProductGroupId,
      };
      return val;
    },
    isSidebarActive(val) {
      if (val == true) {
        const dict = {
          custom: {
            customer: {
              required: this.$t("customerNameRequired"),
              alpha: this.$t("customerNameRequired"),
            },

            brand: {
              required: this.$t("brandRequired"),
              alpha: this.$t("brandRequired"),
            },
          },
        };
        Validator.localize("en", dict);
      }
      return val;
    },
  },
  computed: {
    stockGroupExpertize: {
      get() {
        return this.$store.state.stock.StockGroupExpertize;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
  },
};
</script>
